<template>
  <div>
    <div class="button-area">
      <Button @click="back()" class="button-right">返回</Button>
    </div>
    <Form :model="model" inline style="width: 1100px;margin:0 auto;"  :label-width="140" label-position="left">
      <FormItem label="企业名称">
        <Input
          readonly
          style="width: 320px"
          class="query-model"
          placeholder="企业名称"
          v-model="model.name"
        ></Input>
      </FormItem>
      <FormItem label="诉求类别">
        <Input
          style="width: 320px"
          readonly
          class="query-model"
          placeholder="诉求类别"
          v-model="model.type"
        ></Input>
      </FormItem>
      <br />
      <FormItem label="联系人">
        <Input
          readonly
          style="width: 320px"
          class="query-model"
          placeholder="联系人"
          v-model="model.concat"
        ></Input>
      </FormItem>
      <FormItem label="联系方式">
        <Input
          style="width: 320px"
          readonly
          class="query-model"
          placeholder="联系方式"
          v-model="model.phone"
        ></Input>
      </FormItem>
      <br />
      <FormItem label="所在区域">
        <Input
          style="width: 320px"
          readonly
          class="query-model"
          placeholder="所在区域"
          v-model="model.area"
        ></Input>
      </FormItem>
      <FormItem label="提出时间">
        <Input
          style="width: 320px"
          readonly
          class="query-model"
          placeholder="提出时间"
          v-model="model.createTime"
        ></Input>
      </FormItem><br>
      <FormItem label="解决时间">
        <Input
          style="width: 320px"
          readonly
          class="query-model"
          placeholder="解决时间"
          v-model="model.updateTime"
        ></Input>
      </FormItem>
      <FormItem label="诉求内容">
        <Input
          readonly
          style="width: 320px"
          class="query-model"
          type="textarea"
          placeholder="诉求内容"
          v-model="model.content"
        ></Input>
      </FormItem><br>
      <FormItem label="图片" readonly>
        <div v-if="model.pic">
          <div v-for="(item, index) in model.pic" :key="index">
            <img style="width: 200px; height: 160px" :src="item.url" alt="" />
          </div>
        </div>
        <div v-else>
          <img
            style="width: 200px; height: 160px"
            src="../../../../assets/noPic.jpg"
            alt=""
          />
        </div>
      </FormItem><br>
      <FormItem label="反馈内容">
        <Input
          readonly
          type="textarea"
          style="width: 320px"
          :rows="4"
          class="query-model"
          placeholder="反馈内容"
          v-model="model.feedbackContent"
        ></Input>
      </FormItem><br>
      <FormItem label="反馈单位">
        <Input
          readonly
          style="width: 320px"
          class="query-model"
          placeholder="反馈内容"
          v-model="model.feedbackUnit"
        ></Input>
      </FormItem>
    </Form>
<div style="display:flex;justify-content:center;">
   <Button type="primary" @click="modal1 = true;model2={
     feedbackUnit:'',
     feedbackContent:''
   };" >填写反馈</Button>
</div>
   
    <CModal v-model="modal1" :okLoading="okLoading" title="填写反馈" @on-ok="ok" @on-cancel="cancel">
      <Form v-if="modal1" :model="model2" :rules="ruleValidate" ref="txfk">
        <FormItem label="反馈内容" prop="feedbackContent">
          <Input
          v-model="model2.feedbackContent"
            style="width: 320px"
            type="textarea"
            class="query-model"
            placeholder="多行输入"
            clearable
          ></Input>
        </FormItem>
        <FormItem label="反馈单位" prop="feedbackUnit">
          <Input
           v-model="model2.feedbackUnit"
            type="text"
            style="width: 320px"
            class="query-model"
            placeholder="单行输入"
            clearable
          ></Input>
        </FormItem>
      </Form>
    </CModal>
  </div>
</template>

<script>
import util from "@/libs/util.js";
import CModal from '@/components/cModel'

export default {
  name: "tqtAppealForm",
  components:{CModal},
  data() {
    return {
      model2:{
        feedbackUnit:'',
        feedbackContent:'',
      },
      ruleValidate:{
        feedbackContent:[{required: true, message: '请填写反馈内容'}],
        feedbackUnit:[{required: true, message: '请填写反馈单位'}]
      },
      okLoading:false,
      modal1: false,
      //ID
      id: null,
      saveLoading: false,
      //表单参数
      model: {
        name: "",
        companyid: null,
        id: null,
        type: null,
        code: null,
        concat: null,
        phone: null,
        email: null,
        content: null,
        pic: null,
        gz: null,
        num: null,
        money: null,
        cldkmoney: null,
        cldkhzyh: null,
        czyx: null,
        xzdkmoney: null,
        xzdkhzyh: null,
        status: null,
        userid: null,
        feedbackContent: null,
        feedbackUnit:null,
        appealtype: null,
        createtime: null,
        updatetime: null,
      },
    };
  },
  mounted() {
    if (
      typeof this.$route.query.id !== "undefined" &&
      this.$route.query.id !== null &&
      this.$route.query.id !== ""
    ) {
      this.id = this.$route.query.id;
      //ID存在渲染表单
      this.initForm();
    }
  },
  methods: {
    //修改日期格式
     formatTime (UTCDateString) {
                if (!UTCDateString) {
                    return '-'
                }
                function formatFunc (str) {    //格式化显示
                    return str > 9 ? str : '0' + str
                }
                var date2 = new Date(UTCDateString)     //这步是关键
                var year = date2.getFullYear()
                var mon = formatFunc(date2.getMonth() + 1)
                var day = formatFunc(date2.getDate())
                var hour = date2.getHours()
                var min = formatFunc(date2.getMinutes())
                var second = formatFunc(date2.getSeconds())
                var dateStr = year + '-' + mon + '-' + day 
                return dateStr
            },
    //反馈
    ok() { 
      let _this = this;
      this.$refs.txfk.validate((valid) => {
          if (valid) {
              
      let feedbackUnit = _this.model2.feedbackUnit;
      let feedbackContent = _this.model2.feedbackContent;
      this.okLoading = true;
      util.http
        .put("api/updateByPrimaryKey", {
            feedbackUnit:feedbackUnit,
            feedbackContent:feedbackContent,
            id:_this.$route.query.id,
            userId:_this.$route.query.userId,
        })
        .then((response) => {
              if (response.status === 200) {
                _this.$Notice.success({
                  title: "提交成功",
                });
                _this.model.status = 1;
                _this.model.feedbackUnit = feedbackUnit;
                _this.model.feedbackContent = feedbackContent;
                this.modal1 = false;
              } else {
                _this.$Notice.error({
                  title: "提交失败",
                });
              }
            }).finally(()=>{
              this.okLoading = false;
            });
          } else {
              this.$Message.warning('请检查填写的信息');
          }
      })
    },
    //保存
    save() {
      if (this.id) {
        this.update();
      } else {
        this.create();
      }
    },

    create() {
      let _this = this;
      _this.saveLoading = true;
      util.http
        .post("/api/tqtAppeals", this.model, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          _this.$Notice.success({
            title: "保存成功!",
          });
          _this.back();
        })
        .catch(function (error) {
          _this.$Notice.error({
            title: "保存失败!",
          });
          _this.saveLoading = false;
          console.log(error);
        });
    },

    update() {
      let _this = this;
      _this.saveLoading = true;
      util.http
        .put("/api/tqtAppeals", this.model, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          _this.$Notice.success({
            title: "更新成功!",
          });
          _this.back();
        })
        .catch(function (error) {
          _this.$Notice.error({
            title: "更新失败!",
          });
          _this.saveLoading = false;
          console.log(error);
        });
    },

    //渲染表单
    initForm() {
      let _this = this;
      util.http
        .get("/api/tqtAppeals/" + this.id)
        .then(function (response) {
          let tem = response.data;
          _this.model.name = tem.name,
            _this.model.type = tem.appealTypeName,
            _this.model.concat = tem.concat,
            _this.model.phone = tem.phone,
            _this.model.area = tem.area,
            _this.model.createTime = _this.formatTime(tem.createTime),
            _this.model.updateTime = _this.formatTime(tem.updateTime),
            _this.model.content = tem.content,
            _this.model.feedbackContent = tem.feedbackContent,
            _this.model.feedbackUnit = tem.feedbackUnit,
            _this.model.pic = tem.pic;
        })
        .catch(function (error) {
          _this.$Notice.error({
            title: "获取表单失败!",
          });
          console.log(error);
        });
    },

    //返回,需要自定义配置路由
    back() {
      this.$store.commit('app/closePage', {
          vm: this,
          route:{
            name:'tqt_appeal',
            query:{
              tabName:'name1'
            }
          }
      })
    },
    cancel(){

    }
  },
};
</script>

<style scoped>
.button-area {
  display: flex;
  justify-content: flex-end;
}

.button-right-left {
  margin-right: 15px;
}

.button-right {
  margin-right: 55px;
}

.form-area {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}

.form-flex {
  display: flex;
  justify-content: space-between;
}

.model-hidden {
  display: none;
}
.ivu-input-wrapper{
  vertical-align: top;
}
.ivu-form-item{
        margin-right:60px
    }
</style>
